import { Component } from "@angular/core";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "rc-modal-header",
  templateUrl: "./modal-header.component.html",
  styleUrls: ["./modal-header.component.scss"],
  standalone: false,
})
export class ModalHeaderComponent {
  constructor(public readonly modalController: ModalController) {}
}
